import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../App';
import { useAppSelector } from '../../app/hooks';
import { showWallet } from '../../helpers/helperFunctions';
import { P3 } from '../../styles/FontStyles';
import { BoxPortfolio } from './Portfolio.styled';

export const Wallet = () => {
  const { t } = useTranslation('my_hubs');

  const EXPLORER_LINK = process.env.REACT_APP_EXPLORER_LINK;
  const { walletSummary } = useAppSelector((state) => state.portfolio);

  if (!walletSummary?.userAddress) return null;
  return (
    <div style={{ textAlign: 'right' }}>
      <Desktop>
        <P3 style={{ marginBottom: 10 }}>{t('my_wallet')}</P3>

        <a
          href={`${EXPLORER_LINK}/address/${walletSummary?.userAddress}`}
          target='_blank'
          rel='noreferrer'>
          <BoxPortfolio style={{ borderRadius: 8 }}>
            {walletSummary?.userAddress}
          </BoxPortfolio>
        </a>
      </Desktop>

      <Mobile>
        <a
          href={`${EXPLORER_LINK}/address/${walletSummary?.userAddress}`}
          target='_blank'
          rel='noreferrer'>
          <BoxPortfolio style={{ borderRadius: 8 }}>
            {showWallet(walletSummary?.userAddress, -20)}
          </BoxPortfolio>
        </a>
      </Mobile>
    </div>
  );
};
